import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import apiClient from '../api/client';
import './Courses.css';

export default function CertificateVerification() {
  const { token } = useParams();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiClient.get(`/courses/certificates/verify/${token}`)
      .then((res) => setResult(res.data))
      .catch((err) => {
        setResult(
          err.response?.data || {
            valid: false,
            message: 'Certificate could not be verified.',
          }
        );
      })
      .finally(() => setLoading(false));
  }, [token]);

  return (
    <div className="courses-page">
      <section className="section">
        <div className="container" style={{ maxWidth: 820 }}>
          {loading ? (
            <div className="card course-loading">
              <p>Verifying certificate…</p>
            </div>
          ) : result?.valid ? (
            <div className="certificate-section">
              <div className="certificate-card">
                <div className="certificate-inner">
                  <div className="certificate-kicker">
                    GLOBAL MIND WELLNESS CENTRE
                  </div>

                  <div className="certificate-rule" />

                  <p className="certificate-label">
                    VERIFIED CERTIFICATE
                  </p>

                  <h2>Certificate of Completion</h2>

                  <div className="certificate-recipient">
                    {result.certificate.recipientName}
                  </div>

                  <p className="certificate-text">
                    Successfully completed
                  </p>

                  <div className="certificate-course">
                    {result.certificate.courseTitle}
                  </div>

                  <p className="certificate-text">
                    This certificate was issued by Global Mind Wellness Centre
                    and has been verified against the Centre's certificate
                    records.
                  </p>

                  <div className="certificate-footer">
                    <div className="certificate-signature-block">
                      <div className="certificate-signature">
                        Susan Amdany
                      </div>
                      <div className="certificate-signature-line" />
                      <strong>{result.certificate.signerName}</strong>
                      <span>{result.certificate.signerTitle}</span>
                    </div>

                    <div className="certificate-details">
                      <strong>{result.certificate.certificateNumber}</strong>
                      <span>
                        Issued{' '}
                        {new Date(
                          result.certificate.issuedAt
                        ).toLocaleDateString()}
                      </span>
                      <span>Verification status: Valid</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="certificate-actions">
                <Link to="/courses" className="btn btn-primary">
                  Explore Courses
                </Link>
                <Link to="/" className="btn certificate-verify-button">
                  Global Mind Wellness Centre
                </Link>
              </div>
            </div>
          ) : (
            <div className="card course-empty">
              <span className="eyebrow">Certificate Verification</span>
              <h1>Certificate not verified</h1>
              <p>
                {result?.message ||
                  'This certificate could not be found in the Global Mind Wellness Centre records.'}
              </p>
              <Link to="/courses" className="btn btn-primary">
                Return to Courses
              </Link>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
